import * as Yup from "yup";

export const formSchema = Yup.object().shape({
  title: Yup.string().required("Title is required"),
  status: Yup.string().required("Status is required"),
});
